import { useState } from "react";
import { useTranslation } from 'react-i18next';

const ExperiencesSection = ({ experiencias, ruta, lang }) => {
    const { t } = useTranslation();

    const [activeTab, setActiveTab] = useState(experiencias && experiencias.length > 0 ? experiencias[0].id : 0);

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <div className="container">
            <h2 className="text-center h1">{t("Una experiencia para cada momento")}</h2>
            <p className="mb-6 text-lg text-center mx-645">
                {t("Apartamentos que se adaptan a tu momento vital, compartiendo una misma esencia y estándar de calidad")}
            </p>
            <c-tabs>
                <div className="c-tabs-swiper">
                    <div className="o-cont-fullw" style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <div className="mb-4 mb-md-6" style={{ width: "100%", maxWidth: "max-content" }}>
                            {experiencias.map((unaexperiencia, index) => (
                                <swiper-slide role="group" aria-label={` ${index} / ${experiencias.length}`} style={{ marginRight: "48px" }}
                                    onClick={() => setActiveTab(unaexperiencia.id)} key={index}>
                                    <a className={`c-tabs-swiper_btn-tab toupper ${activeTab === unaexperiencia.id ? 'active' : ''}`} style={{ textDecoration: "none" }}>{unaexperiencia.nombre[lang]}</a>
                                </swiper-slide>
                            ))
                            }
                        </div>
                    </div>
                    <ul ngbnav="" className="nav d-none" role="tablist">
                        <li className="nav-item" role="presentation">

                        </li>
                        <li className="nav-item" role="presentation">

                        </li>
                        <li className="nav-item" role="presentation">

                        </li>
                        <li className="nav-item" role="presentation">

                        </li>
                        <li className="nav-item" role="presentation">

                        </li>
                        <li className="nav-item" role="presentation">

                        </li>
                        <li className="nav-item" role="presentation">

                        </li>

                    </ul>
                    <div className="mt-3 tab-content">
                        {experiencias.map((unaexperiencia, index) => (
                            (index % 2 === 0 ?
                                <div ngbnavpane="" className={`tab-pane fade ${activeTab === unaexperiencia.id ? ' active show' : ''}`} id={`ngb-nav-${index}-panel`} role="tabpanel" aria-labelledby={`ngb-nav-${index}`} key={index}>
                                    <div className="row">

                                        <div className="col-md-6 col-lg-7">
                                            <figure className="mb-0 o-cont-fullw o-cont-md-fullw__left not-xl-fullw img-100-md mh-520">
                                                {unaexperiencia.imagen ?
                                                    <img src={`${ruta}/experiencias/${unaexperiencia.id}/${unaexperiencia.imagen}`} className="o-cover" />
                                                    :
                                                    <img src="/images/web/bedloop-nofoto.png" className="o-cover" />
                                                }
                                            </figure>
                                        </div>

                                        <div className="mt-auto col-md-6 col-lg-5 ps-md-6">
                                            <h4 className="mb-3 h3 c-tabs-swiper_title">{unaexperiencia.nombre[lang]}</h4>
                                            <div className="pb-4 text-sm">
                                                <em dangerouslySetInnerHTML={{ __html: unaexperiencia.texto[lang] }}>

                                                </em>
                                            </div>
                                            {/*<a className="btn btn-primary btn-xs-full" href={"/" + preidioma + t("experiencias") + "/" + unaexperiencia.url_dinamica[lang]}>{unaexperiencia.nombre[lang]}</a>*/}
                                        </div>
                                    </div>
                                </div>
                                :
                                <div ngbnavpane="" className={`tab-pane fade ${activeTab === unaexperiencia.id ? ' active show' : ''}`} id={`ngb-nav-${index}-panel`} role="tabpanel" aria-labelledby={`ngb-nav-${index}`} key={index}>
                                    <div className="row">
                                        <div className="order-1 mt-4 col-md-4 mt-md-auto order-md-0">
                                            <h4 className="mb-3 h3 c-tabs-swiper_title">{unaexperiencia.nombre[lang]}</h4>
                                            <div className="pb-4 text-sm">
                                                <em dangerouslySetInnerHTML={{ __html: unaexperiencia.texto[lang] }}>
                                                </em>
                                            </div>
                                            {/*<a className="btn btn-primary btn-xs-full" href={"/" + preidioma + t("experiencias") + "/" + unaexperiencia.url_dinamica[lang]}>{unaexperiencia.nombre[lang]}</a>*/}
                                        </div>
                                        <div className="col-md-6 col-lg-7">
                                            <figure className="mb-0 o-cont-fullw o-cont-md-fullw__right not-xl-fullw img-100-md mh-520">
                                                {unaexperiencia.imagen ?
                                                    <img src={`${ruta}/experiencias/${unaexperiencia.id}/${unaexperiencia.imagen}`} className="o-cover" />
                                                    :
                                                    <img src="/images/web/bedloop-nofoto.png" className="o-cover" />
                                                }
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            )

                        ))
                        }
                    </div>
                </div>
            </c-tabs>
        </div>
    );
}

export default ExperiencesSection;
